import React from 'react';
import { Surface } from '@americanexpress/dls-react';
import useBreakpoint from '../../../../hooks/useBreakpoint';

export function Layout(props) {
  const children = props.children;
  const isSmallBreakpoint = useBreakpoint('small');
  const isXSmallBreakpoint = useBreakpoint('xSmall');
  const isMobileView = isSmallBreakpoint || isXSmallBreakpoint;
  const surfaceStyle = props.surfaceStyle ? props.surfaceStyle : 'pad-2 pad-3-lg-up';

  if (isMobileView) {
    return (
      <div>
        <div className="margin-1-tb">
          <Surface variant="foreground" className={`${surfaceStyle} border radius-container-sm`}>
            {children}
          </Surface>
        </div>
      </div>
    );
  }
  return (
    <div>
      <div className="margin-1-tb">
        <Surface variant="foreground" className={`${surfaceStyle} border radius-container-sm`}>
          {children}
        </Surface>
      </div>
    </div>
  );
}
